import {
  IconCheckouts,
  IconInbox,
  IconMail,
  IconPlanning,
  IconProfilePlacementUser,
  IconUsers,
} from 'assets/img';
import { PARTNER_PATHS } from 'partner/paths';
import { useTranslation } from 'react-i18next';
import { getPlacementsDefaultFilter } from './utils';

export const useSidebarItems = () => {
  const { t } = useTranslation('partner-screen-specific');

  return [
    {
      key: 'dashboard',
      name: t('sidebar.dashboard'),
      children: [
        {
          ...PARTNER_PATHS.ShiftsPlanning,
          key: 'planning',
          label: t('sidebar.planning'),
          icon: <IconPlanning />,
        },
        {
          ...PARTNER_PATHS.Placement,
          key: 'placement',
          path: `${PARTNER_PATHS.Placement.path}${getPlacementsDefaultFilter()}`,
          label: t('sidebar.placements'),
          icon: <IconProfilePlacementUser />,
        },
        {
          ...PARTNER_PATHS.Inbox,
          key: 'inbox',
          label: t('sidebar.inbox'),
          icon: <IconMail />,
        },
        {
          ...PARTNER_PATHS.Checkout,
          key: 'checkouts',
          label: t('sidebar.checkouts'),
          icon: <IconInbox />,
        },
        {
          ...PARTNER_PATHS.CheckedOut,
          key: 'checked-out',
          label: t('sidebar.checked_out'),
          icon: <IconCheckouts />,
        },
        {
          ...PARTNER_PATHS.Worker,
          key: 'workers',
          label: t('sidebar.workers'),
          icon: <IconUsers />,
        },
      ],
    },
  ] as const;
};
